import React, {useEffect, useState} from "react";
import InputMask from 'react-input-mask';
import Skeleton from "react-loading-skeleton";
import Select from "react-select";
import ApiService from "../util/ApiService";
import StatesSelect from "../util/StatesSelect";

const PersonalDetailsTab = ({usersAlter, handleChange, handleCpfCnpjChange, handleSubmit, loadingPage, loadingSave}) => {


    const [ufs, setUfs] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);

    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption);
    };






    useEffect(() => {
        if (usersAlter?.state) {
            loadCities(usersAlter.state);
        } else {
            setCities([]);
        }
    }, [usersAlter?.state]);


    const normalizeName = (name) =>
        (name || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim()
            .toLowerCase();

    // Carrega as cidades da UF. Recebe a sigla (string), não a option do select.
    const loadCities = (uf) => {
        ApiService.send("post", process.env.REACT_APP_URL_API + "address/city-uf", {uf: uf}, false)
            .then((res) => {
                const data = res.data;

                if (!data.errors) {
                    const options = data.map((city) => ({
                        value: city.id,
                        label: city.name,
                        latitude: city.latitude,
                        longitude: city.longitude,
                    }));

                    setCities(options);

                    // Quando o endereço vem do CEP só temos o nome da cidade;
                    // casa com a lista pra preencher o id_city que o cadastro exige.
                    if (!usersAlter?.id_city && usersAlter?.city) {
                        const match = options.find(
                            (option) => normalizeName(option.label) === normalizeName(usersAlter.city)
                        );

                        if (match) {
                            handleChange({target: {name: 'id_city', value: match.value}});
                        }
                    }
                }
            })
            .catch((error) => {

            });

    };

    // Recebe a option do react-select ({value, label}) e grava a sigla no formulário.
    const handleUfChange = (selectedOption) => {
        const uf = selectedOption?.value || '';

        setSelectedCity(null); // Resetar a cidade quando o estado mudar

        handleChange({target: {name: 'state', value: uf}});
        handleChange({target: {name: 'id_city', value: ''}});
        handleChange({target: {name: 'city', value: ''}});
    };

    return (
        <div className="tab-pane fade show active" id="per_details_tab">
            <div className="row">
                <div className="col-lg-12">

                    <div className="card-body">
                            <div className="row form-row">
                                <div className="col-12 col-sm-12">
                                    <div className="form-group">
                                        <label>Nome</label>
                                        {loadingPage ? (
                                            <Skeleton height={38}/>
                                        ) : (

                                            <input
                                                type="text"
                                                className="form-control"
                                                name="name"
                                                id="name"
                                                onBlur={handleSubmit}
                                                onChange={handleChange}
                                                defaultValue={usersAlter?.name}
                                            />
                                        )}
                                    </div>
                                </div>

                                <hr/>

                                <div className="col-12 m-3">

                                    <strong>Endereço</strong>

                                </div>
                                <div className="col-12 col-sm-6">
                                    <div className="form-group">
                                        <label>CEP</label>
                                        {loadingPage ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <InputMask
                                                mask="99999-999"
                                                value={usersAlter?.zipcode}
                                                name="zipcode"
                                                id="zipcode"
                                                className="form-control"
                                                onChange={handleChange}
                                            />
                                        )}

                                    </div>
                                </div>
                                <div className="col-8">
                                    <div className="form-group">
                                        <label>Logradouro</label>

                                        {loadingPage ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <input
                                                type="text"
                                                name="street"
                                                id="street"
                                                onChange={handleChange}
                                                className="form-control"
                                                value={usersAlter?.street}

                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="col-4 col-sm-4">
                                    <div className="form-group">
                                        <label>Nº</label>
                                        {loadingPage ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <input
                                                type="text"
                                                name="number"
                                                onChange={handleChange}
                                                className="form-control"
                                                defaultValue={usersAlter?.number}

                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12">
                                    <div className="form-group">
                                        <label>Bairro</label>
                                        {loadingPage ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <input
                                                type="text"
                                                name="district"
                                                id="district"
                                                onChange={handleChange}
                                                className="form-control"
                                                value={usersAlter?.district}

                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6">
                                    <div className="form-group col-12">
                                        <label>Estado</label>
                                        {loadingPage ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <StatesSelect  value={usersAlter?.state ? { value: usersAlter.state, label: usersAlter.state } : null}  onChange={handleUfChange} />

                                        )}
                                    </div>

                                </div>
                                <div className="col-12 col-sm-6">
                                    <div className="form-group">
                                        <label>Cidade</label>
                                        {loadingPage ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <Select
                                                value={cities.find(option => option.value === usersAlter?.id_city) || null}
                                                onChange={(option) => {
                                                    handleChange({target: {name: 'id_city', value: option.value}});
                                                    handleChange({target: {name: 'city', value: option.label}});
                                                }}
                                                options={cities}

                                                placeholder="Selecione a Cidade"
                                                isDisabled={!cities}
                                                isSearchable
                                                menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                styles={{
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    }), // Definindo z-index alto
                                                    menu: base => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    }) // Ajuste de z-index no próprio menu
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>

                                    <div className="mt-2 mb-2 d-flex  col-12">
                                        <button type="button"
                                            className="btn btn-primary mt-5"
                                            onClick={() => handleSubmit()}
                                            disabled={loadingSave}
                                        >
                                            {loadingSave ? (
                                                <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"></span>
                                                    Salvando...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa fa-save"></i> Salvar
                                                </>
                                            )}
                                        </button>

                                    </div>

                                </div>
                    </div>

                </div>
            </div>
        </div>
);
};

export default PersonalDetailsTab;
